import { render } from "./CZAssetRegisterSupplier.vue?vue&type=template&id=4ed6029e&scoped=true&ts=true"
import script from "./CZAssetRegisterSupplier.vue?vue&type=script&lang=ts"
export * from "./CZAssetRegisterSupplier.vue?vue&type=script&lang=ts"

import "./CZAssetRegisterSupplier.vue?vue&type=style&index=0&id=4ed6029e&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6029e"]])

export default __exports__